/*! Titanoré Labs — Chef's Pan canonical LP redirect (bust page_cache ghosts) */
(function () {
  try {
    var path = (location.pathname || '').toLowerCase().replace(/\/+$/, '') || '/';
    var CANON = '/pages/chefs-pan-now';
    var CANON_NL = '/nl/pages/chefs-pan-now';
    var HOME_NL = '/nl';
    var LPB_TO_HOME = {
      '/pages/chefs-pan-b': HOME_NL,
      '/pages/home-b': HOME_NL,
      '/nl/pages/chefs-pan-b': HOME_NL,
      '/nl/pages/home-b': HOME_NL
    };
    var homeDest = LPB_TO_HOME[path];
    if (homeDest) {
      location.replace(homeDest + location.search + location.hash);
      return;
    }
    var EN = {
      '/pages/buy-chefs-pan': CANON,
      '/pages/get-chefs-pan': CANON,
      '/pages/buy-chefs-pan-now': CANON,
      '/pages/shop-chefs-pan': CANON,
      '/pages/shop-the-chefs-pan': CANON,
      '/pages/chefs-pan': CANON,
      '/pages/chefs-pan-buy': CANON,
      '/pages/chefs-pan-deal': CANON,
      '/pages/chefs-pan-shop': CANON,
      '/pages/chefs-pan-live-a': CANON
    };
    var NL = {
      '/nl/pages/buy-chefs-pan': CANON_NL,
      '/nl/pages/get-chefs-pan': CANON_NL,
      '/nl/pages/buy-chefs-pan-now': CANON_NL,
      '/nl/pages/shop-chefs-pan': CANON_NL,
      '/nl/pages/shop-the-chefs-pan': CANON_NL,
      '/nl/pages/chefs-pan': CANON_NL,
      '/nl/pages/chefs-pan-buy': CANON_NL,
      '/nl/pages/chefs-pan-deal': CANON_NL,
      '/nl/pages/chefs-pan-shop': CANON_NL,
      '/nl/pages/chefs-pan-live-a': CANON_NL
    };
    var dest = EN[path] || NL[path];
    var destHash = '';
    var saleRoot = path.indexOf('/nl/') === 0 ? '/nl/pages/set-sale' : '/pages/set-sale';
    var colHash = {
      all: '',
      'all-products': '',
      'alle-pannen': '',
      'titanium-pan': '#pannen',
      sets: '#sets',
      'titanium-cutting-system': '#planken',
      'cutting-boards': '#planken',
      'cutting-board': '#planken',
      'kitchen-accessories-collection': '#accessoires'
    };
    var colMatch = path.match(/\/collections\/([^/]+)$/);
    if (!dest && colMatch && Object.prototype.hasOwnProperty.call(colHash, colMatch[1])) {
      dest = saleRoot;
      destHash = colHash[colMatch[1]] || '';
    }
    // chef-deal-* (non US/UK regional) → chefs-pan-now
    if (!dest && /^\/pages\/chef-deal-/.test(path) && !/-us$/.test(path) && !/-uk$/.test(path)) {
      dest = CANON;
    }
    if (!dest && /^\/nl\/pages\/chef-deal-/.test(path) && !/-us$/.test(path) && !/-uk$/.test(path)) {
      dest = CANON_NL;
    }
    if (dest && path !== dest) {
      location.replace(dest + (location.search || '') + (destHash || location.hash || ''));
      return;
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rewriteAllePannenLinks);
    } else {
      rewriteAllePannenLinks();
    }
  } catch (e) {}

  function rewriteAllePannenLinks() {
    try {
      var dest = location.pathname.indexOf('/nl/') === 0 ? '/nl/pages/set-sale' : '/pages/set-sale';
      var map = {
        all: dest,
        'all-products': dest,
        'alle-pannen': dest,
        'titanium-pan': dest + '#pannen',
        sets: dest + '#sets',
        'titanium-cutting-system': dest + '#planken',
        'cutting-boards': dest + '#planken',
        'kitchen-accessories-collection': dest + '#accessoires'
      };
      var nodes = document.querySelectorAll('a[href*="/collections/"]');
      for (var i = 0; i < nodes.length; i++) {
        var href = nodes[i].getAttribute('href') || '';
        var m = href.match(/\/collections\/([^/?#]+)/);
        if (m && map[m[1]]) nodes[i].setAttribute('href', map[m[1]]);
      }
    } catch (e2) {}
  }
})();
